import { gql } from '@apollo/client';

const CREATE_READING_LOG = gql`
  mutation createReadingLog($data: CreateReadingLogInput!) {
    createReadingLog(data: $data) {
      bookId
      pagesRead
      dateStarted
      dateCompleted
      studentReward {
        id
        studentId
        character {
          id
          character
          characterCase
          characterType
        }
      }
    }
  }
`;

export default CREATE_READING_LOG;
